import { render, staticRenderFns } from "./ProductVersionStatistics.vue?vue&type=template&id=e1a0f870&"
import script from "./ProductVersionStatistics.vue?vue&type=script&lang=js&"
export * from "./ProductVersionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProductVersionStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports